<script lang="ts" generics="TValues, TValue">
    import type { Field, Form } from '@jmvdevelop/svelte-form';
    import ModalMobile from '$components/Form/ModalMobile/ModalMobile.svelte';
    import RowInModal from '$components/Form/ModalMobile/RowInModal.svelte';
    import DialogFragment from '$components/MeltUtils/DialogFragment.svelte';
    import { melt } from '@melt-ui/svelte';
    import PrettyChoice, { type Choice } from '$components/Form/PrettyChoice.svelte';
    import { cx } from '$lib/utils/cx';

    export let form: Form<TValues, string>;
    export let field: Field<TValues, TValue>;
    export let label: string;
    export let required: boolean = false;
    export let id: string | null = null;
    export let prefixId: string | undefined = undefined;
    export let modalTitle: string | null = null;
    export let choices: readonly Choice<TValue>[];
    export let areEqual: (a: TValue, b: TValue) => boolean = (a, b) => a === b;

    function getLabel(value: TValue) {
        const c = choices.find((c) => areEqual(c.value, value));
        return c?.label ?? '';
    }

    $: value = form.stores().fieldValue(field);
    $: description = getLabel($value);
</script>

<RowInModal
    {form}
    {field}
    {label}
    {required}
    {prefixId}
    {description}
    {id}
    let:form
    let:field
    let:label
    let:dialog
    let:id
>
    <ModalMobile
        {dialog}
        title={modalTitle ?? label}
        closeIcon="chevron"
        transitionStyle="push"
    >
        <div class="flex-1 px-[20px] py-[14px]">
            <PrettyChoice
                class="b:grid-cols-1 b:gap-0"
                defaultLabelClass={cx(
                    'flex items-center',
                    'px-[10px] m-0',
                    'border hover:border-blue-400',
                    'rounded',
                    'cursor-pointer',
                    'data-[checked]:bg-blue-50 data-[checked]:border-blue-200',
                )}
                defaultTextClass="w-full py-4 ml-2 mb-0 text-14 text-gray-800 font-normal data-[checked]:font-bold"
                {form}
                {field}
                {choices}
                {id}
                {areEqual}
            />
        </div>

        <svelte:fragment slot="footer">
            <DialogFragment {dialog} let:closeEl>
                <button
                    type="button"
                    class="btn-leo btn-leo-primary btn-xl w-full"
                    use:melt={closeEl}
                    >Valider
                </button>
            </DialogFragment>
        </svelte:fragment>
    </ModalMobile>
</RowInModal>
